import { useEffect, useState } from "react";
import { getGroups, getSitesWithCCTVIntegrations } from "../../Api Methods/Api";
import { useDispatch, useSelector } from "react-redux";
import classes from './CCTVIntegrations.module.css'
import CCTVIntegrationsList from "./CCTVIntegrationsList";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import { Await } from "react-router-dom";
import Stats2 from "../../components/UI/Stats/Stats2";
import Button from "../../components/UI/Button/Button";
import ActiveSitesSearchbar from "../ActiveSites/activeSitesSearchbar";
import CCTVIntegrationsSearchBar from "./CCTVIntegrationsSearchBar";
import { sub } from "date-fns";
import DataManager from "../../hooks/DataManager";

const CCTVIntegrations = () => {

    const dispatch = useDispatch();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const apiData = {
        token,
        client
    }
    const [loading, setLoading] = useState(true)
    const [sites, setSites] = useState()   
    const [filteredData, setFilteredData] = useState([])
    const [pageSize, setPageSize] = useState(100)
    const [online, setOnline] = useState(0)
    const [offline, setOffline] = useState(0)
    const [deviceTag, setDeviceTag] = useState(null)
    const [groupName, setGroupName] = useState(null)
    const [integrationType, setIntegraionType] = useState(null) 
    const [submit, setSubmit] = useState(0)
    const [showLoadMore, setShowLoadMore] = useState(true)

    const [totalCount, setTotalCount] = useState(null)
    const [ajaxCount, setAjaxCount] = useState(null)
    const [hikvisionCount, setHikvisionCount] = useState(null)
    const [dahuaCount, setDahuaCount] = useState(null)
    const [aiboxCount, setAiboxCount] = useState(null)

    const [searchTerm, setSearchTerm] = useState("")
    const [groups, setGroups] = useState([])

    const dataManager = new DataManager();

    const listSitesWithCCTVIntegrations = async () => {

        let body = {
            pageSize: 100,
            pageOffset: 0,
            online: online,
            offline: offline,
            deviceTag: deviceTag,
            groupName: groupName,
            integrationType: integrationType
        }

        console.log(body)

        const response = await getSitesWithCCTVIntegrations(apiData, body, dispatch)
        console.log(response.data)

        setTotalCount(response.data[0][0].totalSites)
        setAjaxCount(response.data[0][0].ajaxCount)
        setHikvisionCount(response.data[0][0].hikvisionCount)
        setDahuaCount(response.data[0][0].dahuaCount)
        setAiboxCount(response.data[0][0].aiboxCount)
        setSites(response.data[1])
        setFilteredData(response.data[1])

        if (response.data[1].length < body.pageSize) {
            // e.g. setHasMore(false)
            setShowLoadMore(false)
        }
        
        setLoading(false)
    }

    useEffect(() => {  
        GetGroups();
    }, [])

    useEffect(() => {
        listSitesWithCCTVIntegrations()
    }, [submit])

    const HandleLoadMore = async () => {
        setLoading(true)

        let body = {
            pageSize: 100,
            pageOffset: sites.length,
            online: online,
            offline: offline,
            deviceTag: deviceTag,
            groupName: groupName,
            integrationType: integrationType
        }

        console.log(body)

        const response = await getSitesWithCCTVIntegrations(apiData, body, dispatch)
        console.log(response.data)

       
        setSites(response.data[1])
        setFilteredData(response.data[1])

        if (response.data[1].length < body.pageSize) {
            // e.g. setHasMore(false)
            setShowLoadMore(false)
        }
        
        setLoading(false)
    }

    useEffect(() => {
        const handleDeviceFilter = () => {
            const filtered = sites.filter((item) =>
              Object.values(item)
                .some((value) => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
            );
            dataManager.setItem('cctvSitesSearchTerm', searchTerm); // Store search term
            setFilteredData(filtered); // Update filtered data
          };
        
          if (searchTerm !== dataManager.getItem('cctvSitesSearchTerm')) {
            handleDeviceFilter(); // Call filtering function
          }
    }, [searchTerm])

    const GetGroups = async () => {
        try {
            const listOptions = await getGroups(apiData, dispatch);
            console.log(listOptions);
            setGroups(listOptions || []);
        } catch (error) {
            console.error('Failed to fetch groups:', error);
            setGroups([]);
        }
    }

    return (
        <Await resolve={sites}>
          {(loadedSites) => {
            return (
              <>
                <div className={classes.statsContainer2}>
                    <Stats2 title={"Total integrations"} value={totalCount} isLoadingStats={loading} isStatic={true} />
                    <Stats2 title={"AJAX"} value={ajaxCount} isLoadingStats={loading} isStatic={true}/>
                    <Stats2 title={"Dahua"} value={dahuaCount} isLoadingStats={loading} isStatic={true}/> 
                    <Stats2 title={"Hikvision"} value={hikvisionCount} isLoadingStats={loading} isStatic={true}/> 
                    <Stats2 title={"AIBox"} value={aiboxCount} isLoadingStats={loading} isStatic={true}/> 
                </div>
            
              <div style={{ width: "100%"}}>
              {loading ? (
                <div style={{ display: "flex", width: "100%" }}>
                  <DeviceLoadingGrid
                    CardCount={
                      20
                    }
                  />
                </div>
              ) : (
                <>
                <div className={classes.searchContainer}>

                <CCTVIntegrationsSearchBar
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    groups={groups}
                    online={online}
                    setOnline={setOnline}
                    offline={offline}
                    setOffline={setOffline}
                    deviceTag={deviceTag}
                    setDeviceTag={setDeviceTag}
                    integrationType={integrationType}
                    setIntegrationType={setIntegraionType}
                    groupName={groupName}
                    setGroupName={setGroupName}
                    submit={submit}
                    setSubmit={setSubmit}
                    style={{
                        padding: "10px", 
                        width: "300px",    
                        fontSize: "14px",  
                        boxSizing: "border-box", 
                        borderRadius: "4px",
                    }}/>

                 <div>
                    <p>Total results: {filteredData.length}</p>
                </div>
              </div>
  
                <CCTVIntegrationsList
                    sites={filteredData}
                    setSites={setFilteredData}
                />
                </>
                
              )}
            </div>

            { showLoadMore && <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center', 
                textAlign: 'center',
                marginTop:"5px"
                }}>
                <Button style={{width: "100%"}}label="Load more" onClick={HandleLoadMore}/>
            </div>}
            </>
            )
          }}
        </Await>
      )
}

export default CCTVIntegrations;